import React from "react";
import { HeadlineCardsWide } from "../cards/HeadlineCard";
import SectionImageTitle from "../cards/SectionImage&Title";

export default function MultiColumn({ sections, data }) {
  // const filterData = (name) => {
  //   let filterData = data.filter((item) => item.name === name);

  //   return {
  //     section_name: name,
  //     slug: filterData[0].slug,
  //     items: filterData[0].items.slice(0, 3),
  //   };
  // };

  const filterData = (name) => {
    // Early return if no data
    if (!data?.length) {
      return {
        section_name: name,
        slug: "",
        items: [],
      };
    }

    // Handle Infrastructure case separately
    if (name === "Infrastructure") {
      const infrastructureData = data.find((item) => item.name === name);
      return infrastructureData
        ? {
            section_name: name,
            slug: infrastructureData.slug,
            items: infrastructureData.items.slice(0, 3),
          }
        : {
            section_name: name,
            slug: "",
            items: [],
          };
    }

    // Find the matching section data
    const sectionData = data.find((item) => item.name === name);
    if (!sectionData) {
      return {
        section_name: name,
        slug: "",
        items: [],
      };
    }

    // Helper function to check sections
    const hasRequiredSections = (story) => {
      if (!story?.sections?.length) return false;

      const hasCommentary = story.sections.some((section) => section.name === "Commentary");

      const targetName = name === "From The Archives" ? "From the archives" : name;
      const hasTargetSection = story.sections.some((section) => section.name === targetName);

      return hasCommentary && hasTargetSection;
    };

    // Filter and return items
    return {
      section_name: name,
      slug: sectionData.slug,
      items: sectionData.items.filter((item) => hasRequiredSections(item.story)).slice(0, 3),
    };
  };
  const section0Data = filterData(sections[0]);
  const section1Data = filterData(sections[1]);
  const section2Data = filterData(sections[2]);
  const section3Data = filterData(sections[3]);
  const section4Data = filterData(sections[4]);
  const section5Data = filterData(sections[5]);

  const topCol = [section3Data, section4Data];
  const bottomCol = [section0Data, section1Data, section2Data];
  const leftCol = section5Data;

  return (
    <div className="mt-9 flex flex-col gap-4 mobile:mt-4">
      <div className="flex gap-4 mobile:flex-col">
        <div className="flex w-[67%] gap-8 mobile:w-[100%] mobile:flex-col">
          {topCol.map((item, index) => (
            <div className="flex w-[50%] flex-col gap-3 mobile:w-[100%]" key={index}>
              <SectionImageTitle section={item.items} slug={item.slug} title={item.section_name} />
            </div>
          ))}
        </div>
        <HeadlineCardsWide sectionName={leftCol.items} slug={leftCol.slug} title={leftCol.section_name} />
      </div>
      <div className="mt-5 flex mobile:w-[100%] mobile:flex-col">
        <div className="flex w-[100%] gap-8 mobile:flex-col">
          {bottomCol.map((item, index) => (
            <div className="flex w-[33.3%] flex-col gap-3 mobile:w-[100%]" key={index}>
              <SectionImageTitle section={item.items} slug={item.slug} title={item.section_name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
